import { Card, vars } from '@etg/wings';
import { css } from '@eti/styles';
import type { ResultSetMetaData, TripRoute } from '@eti/schema-types';
import { Overlay } from '@eti/components';
import { useTranslation } from '@eti/providers';
import FiltersButtons from './FiltersButtons';
import FilterContent from './FilterContent';
import type { Filters } from './MobileFilters';

const FiltersOverlayFooter = css`
  border-top: 1px solid ${vars.colors.inputs.main};
`;

interface DesktopDrawerFiltersProps {
  filteredFlightsCount: number;
  isOpen: boolean;
  onClear: () => void;
  onDone: () => void;
  onFilter: (filterOptions: { [key: string]: string[] | null | string }) => void;
  resultSetMetaData: ResultSetMetaData;
  selectedFilters?: Filters;
  searchRoutes: TripRoute[];
}

const DesktopDrawerFilters = ({
  filteredFlightsCount,
  isOpen,
  onClear,
  onDone,
  onFilter,
  resultSetMetaData: { marketingCarriers, priceRange, travelTimeRange },
  selectedFilters,
  searchRoutes,
}: DesktopDrawerFiltersProps) => {
  const { t } = useTranslation();
  return (
    <Overlay.Drawer
      dataTestId="resultPage-filtersDrawerContainer"
      handleClose={onDone}
      isOpen={isOpen}
      shouldOpenHorizontally
    >
      <Overlay.Header onClose={onDone} title={t('Responsive.Air.Result.Filter.Button.Filter')} />
      <Overlay.Content>
        <Card>
          <FilterContent
            onFilter={onFilter}
            resultSetMetaData={{ marketingCarriers, priceRange, travelTimeRange }}
            searchRoutes={searchRoutes}
            selectedFilters={selectedFilters}
          />
        </Card>
      </Overlay.Content>
      <Overlay.Footer className={FiltersOverlayFooter}>
        <FiltersButtons
          filteredFlightsCount={filteredFlightsCount}
          onClear={onClear}
          onDone={onDone}
        />
      </Overlay.Footer>
    </Overlay.Drawer>
  );
};

export default DesktopDrawerFilters;
